// A QuestionStep holds an array of these.
class TextChoice {
    constructor(object) {
        this.text = object.text
        this.value = object.value
    }
}

export default TextChoice
